import React from 'react'
import Loader from './utils/ope-loader'
import createReactClass from 'create-react-class'


var LoadingApp = createReactClass({
  render: function() {
  	return (
      <div className="ope-loading-app">
        <Loader />
      </div>
    );
  }
});

export default LoadingApp;
